import { IRegister } from 'src/app/Models/IRegister';
import { IStatus } from 'src/app/Models/status';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http: HttpClient) { }

  GetPersonalInfo(): Observable<IStatus> {
    return this.http.get<IStatus>('/api/Profile/Profile');
  }
  getImage() : Observable<ArrayBuffer> {
    return this.http.get<ArrayBuffer>('/api/Profile/Picture',
    {responseType: 'arraybuffer' as 'json'});
  }
  updateProfile(user: IRegister): Observable<IStatus> {
    return this.http.post<IStatus>('/api/Profile/UpdateProfileAsync', user, {
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    });
  }
}
